<template>
  <slot v-if="show" />
</template>

<script setup>
import loggedUser from '@/commons/resources/loggedUser';
import { ref } from 'vue';

const props = defineProps({
  permission: {
    type: [String, null],
    required: true
  }
});

const show = ref(props.permission === null || loggedUser.hasPermission(props.permission));
</script>
